'use client';

import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Css, Responsive, UnstyledUl } from '@/ui';
import { theme } from '../../../styles/theme';

interface ICardsContainer {
	columns?: number;
	columnsMobile?: number;
	children: ReactNode;
	flowy?: boolean;
}

export default function CardsContainer({
	columns,
	children,
	columnsMobile,
	flowy,
}: ICardsContainer) {
	return (
		<StyledCardsContainer
			columns={columns}
			columnsMobile={columnsMobile}
			className="cards-container"
			flowy={flowy}
		>
			{children}
		</StyledCardsContainer>
	);
}

export const StyledCardsContainer = styled(UnstyledUl)<{
	columns?: number;
	columnsMobile?: number;
	removeCardBorder?: boolean;
	flowy?: boolean;
}>`
	display: grid;
	grid-column-gap: ${theme.grid?.gutter?.vertical?.default};
	grid-row-gap: ${theme.grid?.gutter?.horizontal?.default};
	padding: 0;
	margin: 0;
	grid-template-columns: ${({ columns }) =>
		columns ? `repeat(${columns}, 1fr)` : `repeat(3, 1fr)`};
	max-width: none !important;

	li {
		margin-top: 0;
		min-width: 0;
	}

	${({ flowy }) =>
		flowy &&
		`
		li {
			height: fit-content;
			box-shadow: ${theme.card?.flowy?.boxShadow};

			&:hover {
				box-shadow: ${theme.card?.flowy?.boxShadow};
			}
		}

		li:nth-child(even) {
			margin-top: ${Css.pxToRem(50)};

			@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
				margin-top: 0;
			}
		}
	`}

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-template-columns: ${({ columnsMobile }) =>
			columnsMobile ? `repeat(${columnsMobile}, 1fr)` : '1fr'};
		grid-row-gap: ${theme.grid?.gutter?.horizontal?.mobile};
	}
`;
